import {useState} from 'react'
import AreaDetailsForm from './AreaDetailsForm';
import AreaDetailsList from './AreaDetailsList';

const AreaDetails = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

return (
  <>
    {fromIsShown ? (
        <AreaDetailsForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
      ) : (
        <AreaDetailsList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
      )}

  </>
)
}

export default AreaDetails